import { Link } from 'react-router-dom'
import {
    Stack,
    Text,
    Flex,
} from '@chakra-ui/react'
import { colors } from 'src/common/colors'
import { ClubBox } from './ClubBox'
import { ClubData } from 'src/hooks/SearchInfo/useGetClubs'

type Props = {
    results: ClubData[]
}

export const ClubResults = (props: Props) => {
    const { results } = props

    return (
        <Stack>
            <Flex justifyContent='space-between' marginBottom='32px'>
                <Text fontFamily='KFAGothic' fontSize='18px' color={colors.darkBlue}>검색 결과</Text>
                <Text fontFamily='KFAGothic' color={colors.button.blue} fontSize='14px'>{results.length}건의 결과</Text>
            </Flex>
            <Flex flexWrap='wrap' justifyContent='space-between'>
                {results.map((result) => {
                    return (
                        <Stack
                            key={result.academyId}
                            width='49%'
                            height='106px'
                            marginBottom='13px'
                            cursor='pointer'
                            padding='16.5px 2.82%'
                            border='1px solid rgba(19, 28, 77, 0.15)'
                            borderRadius='8px'
                        >
                            <Link to={`/search-info/club/${result.academyId}`}>
                                <ClubBox club={result} />
                            </Link>
                        </Stack>
                    )
                })}
            </Flex>
        </Stack>
    )
}